import { inject, Injectable } from '@angular/core';

import { AppLocalStorageService } from 'src/app/features/shared/storage/services/local-storage-services/app-local-storage.service';

/**
 * Cachet machine-vertaalde keys per taal in de geconsolideerde user-boom (tak
 * i18n.cache, platte key→waarde-map per taal), zodat een key maar één keer door de
 * vertaal-API hoeft. Deze cache blijft lokaal (herafleidbaar, potentieel groot) en
 * wordt niet naar de backend gesynct.
 */
@Injectable({ providedIn: 'root' })
export class TranslationCacheService {
    private readonly __store = inject(AppLocalStorageService);

    get(lang: string): Record<string, string> {
        return this.__store.appData$$.i18n.cache()?.[lang] ?? {};
    }

    merge(lang: string, flatPartial: Record<string, string>): void {
        const __all = this.__store.appData$$.i18n.cache() ?? {};
        const __merged = { ...(__all[lang] ?? {}), ...flatPartial };
        this.__store.appData$$.i18n.cache.set({ ...__all, [lang]: __merged });
    }
}
